import { AppContext, EMPTY_OBJECT, UserContext } from 'commons-ui';
import { useContext } from 'react';
import { ESegmentState, ESegmentType } from 'constant';
import { URL, USER_SEGMENT_RESOURCES } from '../../helper';
import useService from '../../useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog, setForceUpdateRows } = params;
	const { showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { requestDeleteSegment, requestActivateSegment, requestRunSegment } = useService();
	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.listSegment]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'view':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.listSegment]}/view`,
					state: {
						rowData
					}
				});
			};
		case 'delete': {
			const deleteSegment = async () => {
				await requestDeleteSegment(rowData, showAlert, user);
				setForceUpdateRows(true);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Are you sure you want to delete this segment? This segment along with the child segments(if any) will be deleted. Please proceeds carefully.',
					handleAlertConfirmation: deleteSegment
				});
			};
		}
		case 'forceDelete': {
			const forceDeleteSegment = async () => {
				await requestDeleteSegment(rowData, showAlert, user, true);
				setForceUpdateRows(true);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Are you sure you want to delete this segment? This segment along with the child segments(if any) will be deleted. Please proceeds carefully.',
					handleAlertConfirmation: forceDeleteSegment
				});
			};
		}
		case 'activate': {
			const activateSegment = async () => {
				await requestActivateSegment(rowData, showAlert, user);
				setForceUpdateRows(true);
			};
			return () => {
				const segmentType: ESegmentType = rowData?.SegmentType;
				const state: ESegmentState = rowData?.state;

				if (
					(segmentType === ESegmentType.LIVE_SEGMENT || segmentType === ESegmentType.DERIVED_SEGMENT) &&
					state === ESegmentState.DRAFT
				) {
					history.push({
						pathname: `${URL[USER_SEGMENT_RESOURCES.listSegment]}/evaluate`,
						state: {
							rowData
						}
					});
				} else {
					setConfirmationDialog({
						show: true,
						header:
							`Are you sure you want to activate this segment? Please proceed carefully.\n\n` +
							`Segment Name: ${rowData.name}, ` +
							`Segment Type: ${rowData.SegmentType}`,
						handleAlertConfirmation: activateSegment
					});
				}
			};
		}
		case 'run': {
			const runSegment = async () => {
				await requestRunSegment(rowData, showAlert, user);
				setForceUpdateRows(true);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header:
						`Are you sure you want to trigger this segment? Please proceed carefully.\n\n` +
						`Segment Name: ${rowData.name}, ` +
						`Segment Type: ${rowData.SegmentType}`,
					handleAlertConfirmation: runSegment
				});
			};
		}
		case 'schedule': {
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.listSegment]}/schedule`,
					state: {
						rowData
					}
				});
			};
		}
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[USER_SEGMENT_RESOURCES.listSegment]}/create`
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
